<template>
<div>
    <div v-if="loading" class="text-center">
        <v-progress-circular color="success" indeterminate rounded height="6" size="20" width="2" />
    </div>
    <div class="d-flex align-center flex-wrap" v-if="items.length > 0">
        <div class="caption font-weight-black grey--text mr-3 mt-1">SOFTNET</div>
        <v-chip
            v-for="item in items" :key="item.id"
            small
            outlined
            color="success"
            class="mr-2 mb-1 font-weight-bold"
        >
            <v-icon x-small left>fas fa-file-invoice</v-icon>
            <softnet-detail :item="item" class="success--text">
                {{ item.document }}
            </softnet-detail>
        </v-chip>
    </div>
</div>
</template>
<script>
import SoftnetDetail from '@/components/softnet/SoftnetDetail.vue'
import {fetchDocuments,getDocument} from '@/api/softnet'
export default {
    name: 'SoftnetDocumentsChips',
    props:['work_order_id'],
    components: {
        SoftnetDetail
    },
    data() {
        return {
            loading: false,
            items:[],
            enabled:this.$store.getters.getCompany.softnet_integration_enabled,
        }
    },
    methods: {
        async fetch(){
            this.items=[]
            if(this.work_order_id&&this.enabled){
                this.loading = true
                const query=`page=1&ordering=created_at&workorder=${this.work_order_id}`
                await fetchDocuments(query)
                .then(res=>{
                    console.log(res)
                    this.items=res.results
                    this.loading = false
                })
                .catch((err)=>{
                    notifications.showError('Error cargando documentos '+err)
                    this.loading = false
                })
            }
        }
    },
    mounted() {
        if(this.work_order_id){
            this.fetch()
        }
    },
    watch:{
        work_order_id:{
            handler:'fetch',
        }
    }
}
</script>
